import { render, staticRenderFns } from "./getParams.vue?vue&type=template&id=48dcf04f&scoped=true&"
import script from "./getParams.vue?vue&type=script&lang=js&"
export * from "./getParams.vue?vue&type=script&lang=js&"
import style0 from "./getParams.vue?vue&type=style&index=0&id=48dcf04f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dcf04f",
  null
  
)

export default component.exports